// OneDrive:IgnoreCodeCoverage
enum PageTransitionType {
    none = 0,
    fullPageLoad = 4,
    onePageAppNavigation = 5
}

export default PageTransitionType;